import type { CustomerAppRequiredCompanyDocumentSchema } from "../api-types/company_data_schemas";
import type { DocumentRequirements, Configuration as KycConfiguration } from "../components/interface";

export function extractDocumentRequirements(
  requirements: CustomerAppRequiredCompanyDocumentSchema[],
  registeredState: string,
  kycConfiguration: KycConfiguration
): DocumentRequirements | undefined {
  if (kycConfiguration.stateRegion.requiredBySearch && !registeredState) {
    return;
  }

  // TODO: move this to a configuration-attached machinery, rather than hard-coding the US-specific process there
  const requirementsForJurisdiction =
    kycConfiguration.country === "US"
      ? requirements.find(({ state }) => state === registeredState)
      : requirements.find(({ country }) => country === kycConfiguration.country);
  const defaultRequirements = requirements.find(({ state }) => state === "DEFAULT");
  const documentRequirements = requirementsForJurisdiction ?? defaultRequirements;
  if (documentRequirements) {
    const { localised_name, description_link } = documentRequirements;
    return {
      requirements: [{ name: localised_name, href: description_link }],
    };
  }
}
